<template>
  <div>
    <v-data-table
      style="margin-inline: 10px"
      class="elevation-5"
      :headers="getHeaderTable(headers)"
      :items="filteredRows"
      :items-per-page="15"
      @update:page="page = $event"
      @update:items-per-page="itemsPerPage = $event"
    >
      <template v-slot:top>
        <div
          style="
            display: flex;
            align-items: center;
            flex-wrap: nowrap;
            padding-inline: 10px;
          "
        >
          <v-text-field
            v-model="search"
            style="width: 40vh; padding-bottom: 5px"
            append-icon="mdi-magnify"
            label="Поиск"
            single-line
            hide-details
          />
          <v-spacer />
          <v-btn
            @click="
              action = 'add';
              selectedOrg = {};
              windowsForEditOrAdd = true;
            "
          >
            Добавить
          </v-btn>
        </div>
      </template>
      <template v-slot:item.action="{ isMobile, index }">
        <td v-bind:class="!isMobile ? 'v-data-table__divider' : ''">
          <v-icon
            small
            class="mdi-pencil"
            color="#00AAAA"
            title="Изменение записи"
            @click="
              $router.push({
                path: `/edit-org/${searchRowByIndex(index).ID}`,
              })
            "
          >
            mdi-pencil
          </v-icon>
          <v-icon
            small
            class="mdi-delete"
            color="#FF0000"
            title="Удаление записи"
            @click="
              windowForDelete = true;
              delayedFunction = function () {
                deleteOrganization(searchRowByIndex(index).ID);
              };
            "
          >
            mdi-delete
          </v-icon>
        </td>
      </template>
      <template
        v-for="header in headers"
        v-slot:[`item.${header.value}`]="{ isMobile, item }"
      >
        <td
          :key="header.value"
          v-if="header.type === 'bool'"
          v-bind:class="!isMobile ? 'v-data-table__divider' : ''"
        >
          {{ item[header.value] ? "Да" : "Нет" }}
        </td>
        <td
          :key="header.value"
          v-else-if="header.type === 'datetime-local'"
          v-bind:class="!isMobile ? 'v-data-table__divider' : ''"
        >
          {{ dateFormatted(item[header.value]) }}
        </td>
        <td
          :key="header.value"
          v-else
          v-bind:class="!isMobile ? 'v-data-table__divider' : ''"
        >
          {{ item[header.value] }}
        </td>
      </template>
    </v-data-table>
    <!--Форма для редактирования-->
    <v-dialog
      v-if="windowsForEditOrAdd"
      v-model="windowsForEditOrAdd"
      persistent
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">{{
            action === "update" ? "Редактирование" : "Добавление"
          }}</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="form" v-model="isValid" lazy-validation>
            <table class="table-form">
              <tbody>
                <template v-for="(header, index) in headers">
                  <tr
                    v-if="
                      header.showIf != null ? selectedOrg[header.showIf] : true
                    "
                    :key="index"
                  >
                    <td>
                      <span>{{ header.text }}</span>
                      <v-text-field
                        rows="1"
                        v-if="header.type === 'datetime-local'"
                        outlined
                        :rules="header.rules"
                        type="datetime-local"
                        hide-details
                        no-resize
                        v-model.trim="selectedOrg[header.value]"
                      ></v-text-field>
                      <v-text-field
                        rows="1"
                        v-if="header.type === 'number'"
                        outlined
                        :rules="header.rules"
                        type="number"
                        hide-details
                        no-resize
                        v-model.number="selectedOrg[header.value]"
                      ></v-text-field>
                      <v-radio-group
                        v-if="header.type === 'bool'"
                        v-model="selectedOrg[header.value]"
                        hide-details
                      >
                        <v-radio :label="`Да`" :value="true"></v-radio>
                        <v-radio :label="`Нет`" :value="false"></v-radio>
                      </v-radio-group>
                      <v-textarea
                        v-if="header.type === 'text'"
                        :rules="header.rules"
                        rows="2"
                        outlined
                        v-model.trim="selectedOrg[header.value]"
                      ></v-textarea>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            text
            @click="
              windowsForEditOrAdd = false;
              $router.push({
                path: `/edit-org`,
              });
            "
          >
            Отмена
          </v-btn>
          <v-btn
            :disabled="!isValid"
            color="blue darken-1"
            text
            @click="editOrAddRow()"
          >
            Сохранить
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--Оповещение об удалении -->
    <v-dialog
      v-if="windowForDelete"
      v-model="windowForDelete"
      width="400"
      persistent
    >
      <v-card>
        <v-alert type="warning" :value="true"> Внимание</v-alert>
        <v-card-text class="text-md-center">
          Вы действительно хотите удалить данную строку?
        </v-card-text>
        <v-card-actions class="text-lg-right">
          <v-spacer />
          <v-btn
            @click="
              delayedFunction();
              windowForDelete = false;
            "
          >
            Да
          </v-btn>
          <v-btn
            @click="
              windowForDelete = false;
              delayedFunction = function () {};
            "
          >
            Нет
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from "axios";
import { bus } from "@/main";

export default {
  name: "edit-org",
  data() {
    return {
      selectedOrg: {},
      isValid: true,
      action: "",
      delayedFunction: function () {},
      windowsForEditOrAdd: false,
      windowForDelete: false,
      headers: [
        {
          text: "Наименование организации",
          value: "caption",
          divider: true,
          rules: [this.required, this.rulesLength(5)],
          type: "text",
        },
        {
          text: "Адрес",
          value: "address",
          rules: [this.required, this.rulesLength(5)],
          divider: true,
          type: "text",
        },
        {
          text: "Телефон",
          value: "phone",
          rules: [(v) => !v || this.rulesPhone(v)],
          divider: true,
          type: "text",
        },
        {
          text: "Примечание",
          value: "description",
          divider: true,
          type: "text",
        },
      ],
      organizations: [],
      search: "",
      page: 1,
      itemsPerPage: 15,
    };
  },
  watch: {
    $route(to) {
      if (
        to.params.id !== undefined &&
        to.params.id !== null &&
        to.params.id !== ""
      ) {
        this.getOrganization(to.params.id);
        this.action = "update";
        this.windowsForEditOrAdd = true;
      } else {
        this.selectedOrg = {};
        this.windowsForEditOrAdd = false;
        this.action = "";
      }
      this.organizations.length <= 0 ? this.getAllOrganizations() : null;
    },
  },
  computed: {
    filteredRows() {
      if (this.organizations != null) {
        let filteredRows = [];
        if (this.search.length < 3 || this.search === "") {
          filteredRows = this.organizations;
          return filteredRows;
        }
        const search = this.search.toLowerCase();
        // eslint-disable-next-line no-unused-vars
        this.organizations.forEach((row) => {
          // eslint-disable-next-line no-unused-vars
          for (const value in row) {
            if (row[value].toString().toLowerCase().includes(search, 0)) {
              filteredRows.push(row);
              break;
            }
          }
        });
        return filteredRows;
      }
      return [];
    },
  },
  methods: {
    dateFormatted(date) {
      if (date == null) {
        return;
      }
      date = date.replace("T", " ");
      date = date.replace("Z", "");
      return date;
    },
    required: (v) => {
      return !!v || "Это обязательное поле";
    },
    rulesPhone: (v) => {
      return (
        /^((8|\+7)[-]?)?(\(?\d{3}\)?[-]?)?[\d\- ]{7,10}$/.test(v) ||
        "Неверное значение"
      );
    },
    rulesLength: (count) => (v) => {
      return v.length > count || "Должно быть не менее " + count + " символов";
    },
    getHeaderTable: function (headers) {
      return [
        {
          text: "Действия",
          value: "action",
          sortable: false,
          divider: true,
        },
        ...headers,
      ];
    },
    editOrAddRow() {
      if (!this.$refs.form.validate()) {
        bus.$emit("message", {
          message: "Информация некорректна",
          color: "red",
        });
        return;
      }
      // eslint-disable-next-line no-unused-vars
      for (const key in this.selectedOrg) {
        if (this.selectedOrg[key].toString().trim() === "") {
          this.selectedOrg[key] = null;
        }
      }
      axios
        .post(`/api/org/${this.action}`, this.selectedOrg)
        .then(() => {
          this.$router.push({ path: "/edit-org" });
          this.selectedOrg = {};
          this.windowsForEditOrAdd = false;
          this.action = "";
          this.getAllOrganizations();
          bus.$emit("message", {
            message: "Сохранено",
            color: "green",
          });
        })
        .catch((e) => {
          if (e.response.status === 401 || e.response.status < 403) {
            bus.$emit("message", {
              message: "Доступ запрещен",
              color: "red",
            });
            return;
          }
          bus.$emit("message", {
            message: "Не удалось внести изменения",
            color: "red",
          });
        });
    },
    // возвращает строчку из уже отфильрованных строк по индексу в таблице
    searchRowByIndex: function (index) {
      if (this.filteredRows.length === 0) {
        return null;
      }
      return this.filteredRows[(this.page - 1) * this.itemsPerPage + index];
    },
    getAllOrganizations() {
      axios
        .post("api/org/get/all")
        .then((orgData) => {
          this.organizations = orgData.data;
        })
        .catch((e) => {
          if (e.response.status === 401 || e.response.status < 403) {
            bus.$emit("message", {
              message: "Доступ запрещен",
              color: "red",
            });
            return;
          }
          bus.$emit("message", {
            message: "Не удалось получить организации",
            color: "red",
          });
        });
    },
    deleteOrganization(id) {
      axios
        .post("api/org/delete", {}, { params: { id: id } })
        .then(() => {
          this.getAllOrganizations();
          bus.$emit("message", {
            message: "Организация удалена",
            color: "green",
          });
        })
        .catch((e) => {
          if (e.response.status === 401 || e.response.status < 403) {
            bus.$emit("message", {
              message: "Доступ запрещен",
              color: "red",
            });
            return;
          }
          bus.$emit("message", {
            message: "Не удалось удалить организацию",
            color: "red",
          });
        });
    },
    getOrganization: function (id) {
      return new Promise((resolve, reject) => {
        axios
          .post("api/org/get", {}, { params: { id: id } })
          .then((orgData) => {
            this.selectedOrg = orgData.data;
            resolve();
          })
          .catch((e) => {
            if (e.response.status === 401 || e.response.status < 403) {
              bus.$emit("message", {
                message: "Доступ запрещен",
                color: "red",
              });
              reject();
              return;
            }
            bus.$emit("message", {
              message: "Не удалось получить организацию",
              color: "red",
            });
            reject();
          });
      });
    },
  },
  async mounted() {
    if (this.$route.params.id !== undefined) {
      await this.getOrganization(this.$route.params.id);
      this.action = "update";
      this.windowsForEditOrAdd = true;
    } else {
      this.getAllOrganizations();
    }
  },
};
</script>

<style scoped>
.v-input--selection-controls {
  margin-top: 0px !important;
}

.table-form {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  height: auto;
}

.table-form td,
th {
  word-wrap: break-word;
  padding: 5px;
}

v-textarea {
  height: 100%;
}
</style>
